import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=731a6d6e&scoped=true"
import script from "./CollectionDetail.vue?vue&type=script&lang=js"
export * from "./CollectionDetail.vue?vue&type=script&lang=js"
import style0 from "./CollectionDetail.vue?vue&type=style&index=0&id=731a6d6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731a6d6e",
  null
  
)

export default component.exports